import { render, staticRenderFns } from "./TeamMembersList.vue?vue&type=template&id=8209d1ca&"
import script from "./TeamMembersList.vue?vue&type=script&lang=js&"
export * from "./TeamMembersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports